// extracted by mini-css-extract-plugin
export default {"container":"columnMapping_container__Gr6LE","text":"columnMapping_text__e4Au4","input":"columnMapping_input__MOMJz"};